import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { BUSINESS, REVIEWS, SERVICES } from "../content/defaults";

const QR = (data) => `${process.env.REACT_APP_BACKEND_URL || ""}/api/qr?data=${encodeURIComponent(data)}`;

function Stars() {
  return (
    <span className="stars" aria-hidden="true">
      {[0, 1, 2, 3, 4].map((i) => <Star key={i} size={13} fill="currentColor" strokeWidth={0} />)}
    </span>
  );
}

export default function Footer() {
  const siteUrl = typeof window !== "undefined" ? window.location.origin : "https://ccc-auto-electric.com";
  return (
    <footer className="footer" data-testid="site-footer">
      <div className="container footer-inner">
        <div className="footer-identity" data-testid="footer-identity">
          <img className="footer-portrait mascot-bob" src="/assets/ccc-mechanic-mascot-portrait.png"
            alt="Close-up of the friendly C.C.C. mechanic mascot" width="110" height="110" />
          <div>
            <div className="footer-wordmark">
              <strong><span className="wm-red">C.C.C.</span> <span className="wm-blue">Auto Electric</span></strong>
            </div>
            <div className="footer-tagline">Auto electric excellence in Hawaiian Gardens</div>
          </div>
          <a className="footer-qr" href={siteUrl} data-testid="footer-site-qr" style={{ marginLeft: "auto" }}
            onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}>
            <img src={QR(siteUrl)} alt="QR code opening the C.C.C. Auto Electric website" width="104" height="104" />
            <span>Visit our website, see all services,<br />or get in touch</span>
          </a>
        </div>

        <div className="footer-grid">
          <div>
            <h5>Explore</h5>
            <Link to="/" data-testid="footer-menu-link-home">Home</Link>
            <Link to="/about" data-testid="footer-menu-link-about">About</Link>
            <Link to="/contact" data-testid="footer-menu-link-contact">Contact</Link>
            <Link to="/blog" data-testid="footer-menu-link-blog">Blog</Link>
          </div>
          <div>
            <h5>Services</h5>
            <Link to="/services/battery-charging" data-testid="footer-service-link-battery-charging">Battery &amp; Charging</Link>
            <Link to="/services/wiring-lighting" data-testid="footer-service-link-wiring-lighting">Wiring &amp; Lighting</Link>
            <Link to="/services/starting-alternator" data-testid="footer-service-link-starting-alternator">Starting &amp; Alternator</Link>
            <Link to="/dealers" data-testid="footer-menu-link-dealers">Dealers Vehicle Check-In</Link>
            <Link to="/staff/login" data-testid="footer-menu-link-staff">Admin Login</Link>
            <Link to="/customer" data-testid="footer-menu-link-customer">Repair Status</Link>
          </div>
          <div className="footer-contact" data-testid="ratings-banner-footer">
            <h5>Contact</h5>
            <a className="tel" href={BUSINESS.phoneHref} data-testid="footer-phone-link">{BUSINESS.phoneDisplay}</a><br />
            {BUSINESS.address}
            <div style={{ marginTop: 12 }} className="ratings-foot">
              <a href={REVIEWS.providers[0].profile} target="_blank" rel="noopener noreferrer" data-testid="footer-rating-google">
                Google&nbsp;&nbsp;{REVIEWS.providers[0].rating} <Stars />
              </a><br />
              <a href={REVIEWS.providers[1].profile} target="_blank" rel="noopener noreferrer" data-testid="footer-rating-yelp">
                Yelp&nbsp;&nbsp;{REVIEWS.providers[1].rating} <Stars />
              </a>
              <small>Ratings displayed by Birdeye and Giftly · checked {REVIEWS.checked}. <a href={REVIEWS.providers[0].write} target="_blank" rel="noopener noreferrer" data-testid="footer-review-link">Leave a Google review</a></small>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div>© {new Date().getFullYear()} {BUSINESS.name}</div>
          <a href="mailto:lawrence@masteraibots.com" data-testid="footer-credit-link"
            style={{ color: "rgba(255,255,255,0.6)", textDecoration: "none" }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#85B2FF")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.6)")}>
            website by Lawrence Williams
          </a>
          <div><Link to="/privacy" data-testid="footer-menu-link-privacy" style={{ color: "inherit" }}>Privacy Policy</Link></div>
        </div>
      </div>
    </footer>
  );
}
